module.exports = __webpack_public_path__ + "static/media/xpg-baccarat.faaf08b0.png";